const bytesToHex = (bytes) =>
  Array.from(bytes)
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')

/**
 * Encripta una cadena con AES-CBC usando Web Crypto.
 * Devuelve el IV concatenado con el texto cifrado, ambos en hexadecimal.
 *
 * @param {string} data - Texto plano a encriptar.
 * @param {string} secretKey - Llave secreta (debe tener al menos 32 caracteres).
 * @returns {Promise<string>} IV (hex) + ciphertext (hex).
 */
const encryptPaymentAdjuster = async (data, secretKey) => {
  try {
    const encoder = new TextEncoder()
    const keyBytes = encoder.encode(secretKey).slice(0, 32)

    if (keyBytes.length < 32) {
      throw new Error('The secret key must be at least 32 bytes long')
    }

    const iv = crypto.getRandomValues(new Uint8Array(16))

    const key = await crypto.subtle.importKey('raw', keyBytes, { name: 'AES-CBC' }, false, [
      'encrypt',
    ])

    const encryptedBuffer = await crypto.subtle.encrypt(
      { name: 'AES-CBC', iv },
      key,
      encoder.encode(data)
    )

    const ivHex = bytesToHex(iv)
    const cipherHex = bytesToHex(new Uint8Array(encryptedBuffer))

    return `${ivHex}${cipherHex}`
  } catch (error) {
    console.error(error)
    throw new Error('The data could not be encrypted')
  }
}

export default encryptPaymentAdjuster
